"use client";

import { Mail, MessageCircle, Sparkles } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Consultationpreparationchecklist() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const steps = [{
    number: "01",
    icon: Mail,
    title: "Initial Inquiry",
    description: "Submit your matter details through our secure intake form. Our team reviews each submission for conflicts and relevance to our core practice areas.",
    time: "Review within 24 business hours",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_inquiry.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_inquiry.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_inquiry.png-wvc-sizes"
  }, {
    number: "02",
    icon: MessageCircle,
    title: "Strategic Consultation",
    description: "Meet with Mr. Levine for a focused discussion on your business, property, or estate matter. We analyze the legal landscape and define clear objectives.",
    time: "60 minute initial session",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/law_office_consultation.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/law_office_consultation.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/law_office_consultation.png-wvc-sizes"
  }, {
    number: "03",
    icon: Sparkles,
    title: "Execution & Resolution",
    description: "We implement the agreed-upon strategy, whether drafting complex contracts, navigating probate, or providing expert witness testimony in fee hearings.",
    time: "Ongoing professional counsel",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_resolution.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_resolution.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_resolution.png-wvc-sizes"
  }];
  return;
}
function StepCard({
  step,
  Icon,
  index
}: {
  step: {
    number: string;
    title: string;
    description: string;
    time: string;
    image: string;
    srcset: string;
    sizes: string;
  };
  Icon: React.ElementType;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <div ref={ref} className={`transition-all ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
    transitionDuration: "700ms",
    transitionDelay: `${index * 80}ms`,
    transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
  }}>
      <Card className="relative h-full bg-card border border-border rounded-lg p-7 transition-all duration-300 hover:border-secondary hover:shadow-lg overflow-hidden group">
        {}
        <div className="flex items-start justify-between mb-6">
          <div className="relative">
            <svg width="56" height="64" viewBox="0 0 56 64" fill="none" className="text-secondary transition-colors duration-300 group-hover:text-primary">
              <path d="M28 6 C 14 22, 10 38, 16 50 C 21 60, 35 60, 40 50 C 46 38, 42 22, 28 6 Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="fill-transparent group-hover:fill-secondary/10 transition-all duration-300" />
            </svg>
            <span className="absolute inset-0 flex items-center justify-center pt-2 font-mono text-sm font-medium text-primary">
              {step.number}
            </span>
          </div>

          {}
          <div className="relative w-14 h-14 rounded-lg overflow-hidden border border-secondary/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-out" style={{
          transitionDelay: "50ms"
        }}>
            <img src={step.image} data-wvc-srcset={step.srcset} data-wvc-sizes={step.sizes} alt={step.title} loading="lazy" decoding="async" className="w-full h-full object-cover" />
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" className="absolute top-1 right-1 text-secondary">
              <path d="M4 1 L5 3 L7 4 L5 5 L4 7 L3 5 L1 4 L3 3 Z" fill="currentColor" />
            </svg>
          </div>
        </div>

        {}
        <div className="mb-4">
          <Icon className="w-5 h-5 text-secondary" strokeWidth={1.5} />
        </div>

        {}
        <h3 className="font-default font-semibold text-xl md:text-2xl text-primary leading-tight mb-3 tracking-tight">
          {step.title}
        </h3>

        {}
        <p className="text-[15px] leading-relaxed text-muted-foreground mb-6 font-default">
          {step.description}
        </p>

        {}
        <div className="flex items-center gap-2 mb-3">
          <span className="h-px flex-1 bg-border" />
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" className="text-secondary/50">
            <path d="M2 5 C 3 3, 5 2, 7 2 M7 2 C 9 2, 11 3, 12 5 M7 2 L7 8" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        {}
        <p className="font-mono text-xs uppercase tracking-[0.04em] text-secondary">
          {step.time}
        </p>
      </Card>
    </div>;
}